import { useState } from "react";
import API from "../../api/api";
import "../../style/add-dept.css";
import { useNavigate } from "react-router-dom";

export default function AddDepartment() {

  const [name, setName] = useState("");
  const [icon, setIcon] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!name.trim()) return;

    try {

      setLoading(true);

      const formData = new FormData();

      formData.append("name", name);

      if (icon) {
        formData.append("icon", icon);
      }

      await API.post(
        "/admin/add-department",
        formData
      );

      setName("");
      setIcon(null);

      alert("Department created successfully");

    } catch (err) {

      console.error("Create department error", err);

      alert("Failed to create department");

    } finally {

      setLoading(false);

    }

  };


  return (
    <div className="admin-dept-page">
       
      <button className="back-button" onClick={() => navigate("/admin/departments")}>
        Back
      </button>

      <h1>Add Department</h1>

      <form
        className="admin-dept-form"
        onSubmit={handleSubmit}
      >

        <div className="form-group">
          <label>Department Name</label>

          <input
            type="text"
            placeholder="Finance"
            value={name}
            onChange={(e) =>
              setName(e.target.value)
            }
            required
          />
        </div>


        <div className="form-group">
          <label>Upload Icon</label>

          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setIcon(e.target.files[0])
            }
          />
        </div>


        <button
          type="submit"
          disabled={loading}
        >
          {loading
            ? "Creating..."
            : "Create Department"}
        </button>

      </form>

    </div>
  );
}